import { styled } from 'twin.macro';

import { hexToRgba } from '@ubisend/pulse-component-hooks';

const DateWrapper = styled.div`
  .MuiPickersBasePicker-pickerView {
    max-width: 100%;
  }

  .MuiDialogActions-root {
    background: black;
  }

  .MuiPickersLayout-root:has(div.MuiDateCalendar-root) {
    height: 404px;
    max-height: 404px;
  }

  .MuiPickersLayout-root:has(div.MuiDateTimePickerToolbar-root) {
    max-height: 404px;
  }

  .MuiDateCalendar-root,
  .MuiPickersYear-yearButton {
    color: rgb(0 0 0 / 0.87);
  }

  .MuiClock-pin,
  .MuiClockPointer-root,
  .MuiClockPointer-thumb,
  .MuiPickersToolbar-root,
  .MuiClockNumber-root.Mui-selected,
  .MuiPickersYear-yearButton.Mui-selected,
  .MuiPickersMonth-monthButton.Mui-selected,
  .MuiButtonBase-root.MuiPickersDay-root.Mui-selected,
  .MuiPickersYear-yearButton.Mui-selected:hover,
  .MuiPickersMonth-monthButton.Mui-selected:hover,
  .MuiButtonBase-root.MuiPickersDay-root.Mui-selected:hover,
  .MuiPickersYear-yearButton.Mui-selected:focus,
  .MuiPickersMonth-monthButton.Mui-selected:focus,
  .MuiButtonBase-root.MuiPickersDay-root.Mui-selected:focus,
  .MuiPickersYear-yearButton.Mui-selected:active,
  .MuiPickersMonth-monthButton.Mui-selected:active,
  .MuiButtonBase-root.MuiPickersDay-root.Mui-selected:active {
    background-color: ${props => props.theme?.bot?.sentMessage?.background || props.theme.primary};
  }

  .MuiPickersYear-yearButton:focus,
  .MuiPickersMonth-monthButton:focus,
  .MuiButtonBase-root.MuiPickersDay-root:focus {
    background-color: ${props => {
    const baseColor = props.theme?.bot?.sentMessage?.background || props.theme.primary;
    return `${hexToRgba(baseColor, 0.2)}`;
  }};
  }

  .MuiTypography-overline,
  .MuiPickersToolbarText-root {
    color: rgb(255 255 255 / 0.54);
  }

  .MuiDatePickerToolbar-title,
  .MuiTypography-overline.Mui-selected,
  .MuiDatePickerToolbar-title.Mui-selected,
  .MuiPickersToolbarText-root.Mui-selected {
    color: #fff;
  }

  .MuiClockPointer-thumb {
    border-color: ${props => props.theme?.bot?.sentMessage?.background || props.theme.primary};
  }

  .MuiPickersLayout-toolbar {
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .MuiDateCalendar-root,
  .MuiTimeClock-root {
    min-height: 305px;
  }

  .MuiClock-root {
    height: 100%;
  }
`;

export default DateWrapper;